import axios from 'axios';
import config from '../config';

const CityGetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}city/all?page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        if (response.status === 201) {
            console.log("citys", response.data);
            return {
                status: 200,
                cities: response.data.cities,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}


//add city
const Add = async (stateId, name) => {
    try {
        const data = new FormData();
        data.append("stateId", stateId);
        data.append("name", name);
        console.log(data);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'city/add', data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 201) {
            return {
                status: 200,
                message: response.data.message,
                city: response.data.city
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

//get by id
const GetById = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}city/get-by-id?id=${id}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            return {
                status: 200,
                city: response.data.city
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400, 
            message: error.response.data.message
        };
    }
}

//update city with id, stateId, name, status
const Update = async (id, stateId, name, status) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("stateId", stateId);
        data.append("name", name);
        data.append("status", status);
        
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(`${config.apiUrl}city/update`, data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                city: response.data.city
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}

export { CityGetAll, Add, GetById, Update };